// PWA service-worker registration + web-push subscription.
// SW registered with updateViaCache:'none' so a new sw.js is always re-fetched
// (sidesteps nginx's 1y immutable cache on *.js). The backend engine is untouched.

export function registerSW() {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {});
  });
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return ('serviceWorker' in navigator) && ('PushManager' in window) && ('Notification' in window);
}

export function pushPermissionState() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'granted' | 'denied' | 'default'
}

// Must be called from a user gesture (required on iOS). Returns { ok, reason }.
export async function enablePush(authFetch, apiUrl) {
  try {
    if (!pushSupported()) return { ok: false, reason: 'unsupported' };
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return { ok: false, reason: 'denied' };

    const reg = await navigator.serviceWorker.ready;
    const keyRes = await fetch(`${apiUrl}/push/vapid-public-key`);
    const { key } = await keyRes.json();
    if (!key) return { ok: false, reason: 'no-vapid' };

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key)
      });
    }
    const res = await authFetch(`${apiUrl}/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(sub)
    });
    if (!res || !res.ok) return { ok: false, reason: 'save-failed' };
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: (e && e.message) || 'error' };
  }
}

// Optional: fire a server-side test push to self (used by the 🔔 button after enabling).
export async function sendTestPush(authFetch, apiUrl) {
  try {
    const res = await authFetch(`${apiUrl}/push/test`, { method: 'POST' });
    return !!(res && res.ok);
  } catch (e) { return false; }
}
